import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { caveatOf } from '../model';
import type { Keypad } from '../model';

export interface FamilyCaveatProps {
  keypad: Keypad;
}

/**
 * What this kind of panel does that a technician cannot program here.
 *
 * A keycard reader's own GPIO transitions are not initialised in this firmware
 * build, so its mapping is written for the next build and does nothing yet. That
 * belongs on screen, next to the panel, rather than in a manual nobody carries.
 */
export const FamilyCaveat: React.FC<FamilyCaveatProps> = ({ keypad }) => {
  const caveat = caveatOf(keypad);
  if (caveat === null) return <></>;
  return (
    <p className="flex items-start gap-2 rounded-xl bg-[#FFF8E8] px-4 py-3 text-sm text-[#8A6A2A]">
      <AlertTriangle className="mt-0.5 h-4 w-4 shrink-0" />
      <span>{caveat}</span>
    </p>
  );
};

export default FamilyCaveat;
